import $ from 'jquery';
import lottie from 'lottie-web';
import { Cookie, Query, LivePerson } from './liveperson-attribution';
import { CONSENT_GROUPS, hasConsent, onConsentChange } from './src/utils/consent';

window.lottie = lottie;

window.readyTimeout = null;

window.lp_attr = {};

window.lpCallbacks = window.lpCallbacks || [];

window.testGated = function () {
    $('.pane.gated').slideDown();
};

window.lpHydrateAttributes = function () {
    if (!hasConsent(CONSENT_GROUPS.performance)) {
        return;
    }

    LivePerson.HydrateAttributes(function () {
        if (!hasConsent(CONSENT_GROUPS.functional)) {
            return;
        }

        LivePerson.waitForChat(function () {
            LivePerson.BindToChat();
        });
    });
};

window.lpHubSpotForms = window.lpHubSpotForms || {
    scriptLoaded: false,
    scriptLoading: false,
    callbacks: [],
    renderedForms: {},
};

window.lpLoadHubSpotFormsScript = function (callback) {
    var scriptId = 'hsFormsV2';
    var existingScript = document.getElementById(scriptId);

    if (window.hbspt && window.hbspt.forms) {
        window.lpHubSpotForms.scriptLoaded = true;
        callback();
        return;
    }

    window.lpHubSpotForms.callbacks.push(callback);

    if (window.lpHubSpotForms.scriptLoading) {
        return;
    }

    window.lpHubSpotForms.scriptLoading = true;

    var script = existingScript || document.createElement('script');
    script.id = scriptId;
    script.src = 'https://js.hsforms.net/forms/v2.js';
    script.defer = true;

    script.onload = function () {
        var callbacks = window.lpHubSpotForms.callbacks.splice(0);
        window.lpHubSpotForms.scriptLoaded = true;
        window.lpHubSpotForms.scriptLoading = false;

        callbacks.forEach(function (queuedCallback) {
            queuedCallback();
        });
    };

    script.onerror = function () {
        window.lpHubSpotForms.scriptLoading = false;
    };

    if (!existingScript) {
        document.head.appendChild(script);
    }
};

window.lpHydrateHubSpotForms = function () {
    var hubSpotFrames = Array.from(document.querySelectorAll('.hs-form-frame[data-portal-id][data-form-id]'));
    var pendingFrames = hubSpotFrames.filter(function (frame) {
        return (
            !frame.getAttribute('data-lp-hubspot-queued') &&
            !frame.getAttribute('data-lp-hubspot-rendered') &&
            !frame.querySelector('form, iframe')
        );
    });

    if (!pendingFrames.length) {
        return;
    }

    pendingFrames.forEach(function (frame) {
        frame.setAttribute('data-lp-hubspot-queued', 'true');
    });

    window.lpLoadHubSpotFormsScript(function () {
        pendingFrames.forEach(function (frame, index) {
            var portalId = frame.getAttribute('data-portal-id');
            var formId = frame.getAttribute('data-form-id');
            var region = frame.getAttribute('data-region') || 'na1';

            if (!portalId || !formId || !window.hbspt || !window.hbspt.forms) {
                frame.removeAttribute('data-lp-hubspot-queued');
                return;
            }

            if (!frame.id) {
                frame.id = `hs-form-${portalId}-${formId}-${index}`.replace(/[^a-zA-Z0-9_-]/g, '-');
            }

            var renderKey = `${portalId}:${formId}:${frame.id}`;

            if (window.lpHubSpotForms.renderedForms[renderKey] || frame.querySelector('form, iframe')) {
                frame.removeAttribute('data-lp-hubspot-queued');
                return;
            }

            frame.innerHTML = '';
            frame.setAttribute('data-lp-hubspot-rendered', 'true');
            window.lpHubSpotForms.renderedForms[renderKey] = true;

            window.hbspt.forms.create({
                region: region,
                portalId: portalId,
                formId: formId,
                target: `#${frame.id}`,
                onFormReady: function () {
                    frame.removeAttribute('data-lp-hubspot-queued');
                    frame.setAttribute('data-lp-hubspot-ready', 'true');
                },
                onFormSubmitted: function () {
                    frame.setAttribute('data-lp-hubspot-submitted', 'true');
                },
            });
        });
    });
};

window.lpObserveHubSpotForms = function () {
    if (window.lpHubSpotForms.observer || !window.MutationObserver) {
        return;
    }

    window.lpHubSpotForms.observer = new MutationObserver(function (mutations) {
        var hasHubSpotFrame = mutations.some(function (mutation) {
            return Array.from(mutation.addedNodes).some(function (node) {
                return (
                    node.nodeType === 1 &&
                    (node.matches?.('.hs-form-frame[data-portal-id][data-form-id]') ||
                        node.querySelector?.('.hs-form-frame[data-portal-id][data-form-id]'))
                );
            });
        });

        if (hasHubSpotFrame) {
            window.lpHydrateHubSpotForms();
        }
    });

    window.lpHubSpotForms.observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
};

window.documentReadyFn = function () {
    window.lottieFiles = [];

    window.lpCallbacks.forEach(function (item) {
        try {
            if (item) {
                item($);
                console.log('cb called');
            }
        } catch (error) {
            console.error('callback failed', error);
        }
    });

    Array.from(document.scripts).forEach(function (item) {
        if (item.attributes['data-type']?.value == 'pageScript') {
            console.log('executing script...');
            eval(item.text);
        }
    });

    window.lpHydrateAttributes();
    window.lpObserveHubSpotForms();
    window.lpHydrateHubSpotForms();

    if (!window.__lpConsentListenerBound) {
        window.__lpConsentListenerBound = true;
        onConsentChange(function () {
            window.lpHydrateAttributes();
        });
    }

    console.log('Document ready.');

    $('body')
        .off('click', 'a.mobileForm')
        .on('click', 'a.mobileForm', function (e) {
            e.preventDefault();
            $('.form--sticky').toggleClass('expanded');
            $('.form--sticky .mktoForm').slideToggle(300);
            $('.span1').toggleClass('swap');
            $('.span2').toggleClass('swap');
        });

    $('body')
        .off('click', '.comp-tabs-a h4.accordion-header button')
        .on('click', '.comp-tabs-a h4.accordion-header button', function (e) {
            e.preventDefault();
            const anchor = $(this).parents('.comp-tabs-a').attr('id');
            $('#' + anchor + ' .accordion-item').removeClass('accordion-item-active');
            $(this).parents('.accordion-item').addClass('accordion-item-active');
            let tabIndex = $(this).data('tab');
            $('#' + anchor + ` .comp-tabs-img[data-tab-content="${tabIndex}"]`).fadeIn();
            $('#' + anchor + ` .comp-tabs-img:not([data-tab-content="${tabIndex}"])`).hide();
        });

    $('body')
        .off('click', '.comp-tabs-b h4.comp-tab')
        .on('click', '.comp-tabs-b h4.comp-tab', function (e) {
            e.preventDefault();
            $('.comp-tabs-b .comp-tabs-list-container h4').removeClass('comp-tab-active');
            $(this).addClass('comp-tab-active');
            let tabIndex = $(this).data('tab');
            $(
                `.comp-tabs-b .comp-tabs-content[data-tab-content="${tabIndex}"], .comp-tabs-b .comp-tabs-img[data-tab-content="${tabIndex}"]`
            ).fadeIn();
            $(
                `.comp-tabs-b .comp-tabs-content:not([data-tab-content="${tabIndex}"]), .comp-tabs-b .comp-tabs-img:not([data-tab-content="${tabIndex}"])`
            ).hide();
        });

    $('body')
        .off('click', '.comp-tabs-c .btn.pill')
        .on('click', '.comp-tabs-c .btn.pill', function (e) {
            e.preventDefault();
            let anchor = $(this).parents('.comp-tabs-c').attr('id');
            if (anchor ? (anchor = `#${anchor}`) : (anchor = ''));

            $(anchor + '.comp-tabs-c .btn.pill').removeClass('pill-active');
            $(e.target).addClass('pill-active');
            let tabIndex = $(e.target).data('tab');
            $(anchor + `.comp-tabs-c .comp-tabs-content[data-tab-content="${tabIndex}"]`).fadeIn();
            $(anchor + `.comp-tabs-c .comp-tabs-content:not([data-tab-content="${tabIndex}"])`).hide();
        });

    document.querySelectorAll('.comp-tabs-c .comp-tabs-content').forEach(function (item) {
        item.style.display = 'none';
    });
    document.querySelectorAll('.comp-tabs-c .comp-tabs-content[data-tab-content="0"]').forEach(function (item) {
        item.style.display = 'flex';
    });

    // setTimeout(function () {
    //     // console.log('This is load scroll position: ' + window.scrollY);
    //     if (window.scrollY > 100) {
    //         $('.pane .container img').animate({ opacity: '1' }, 1000);
    //     } else {
    //         $(window)
    //             .off('scroll')
    //             .on('scroll', function () {
    //                 $('.pane:not(.hero, .gated) .container img').each(function (i) {
    //                     var bottom_of_object = $(this).position().top;
    //                     var bottom_of_window = $(window).scrollTop() + $(window).height();
    //                     if (bottom_of_window > bottom_of_object) {
    //                         $(this).animate({ opacity: '1' }, 1000);
    //                     }
    //                 });
    //             });
    //     }
    // }, 1000);

    $('body').on('input', 'textarea', function () {
        this.style.height = 'auto';
        this.style.height = this.scrollHeight + 'px';
    });

    $('body').on('click', '.edit-post-visual-editor .wp-block', function () {
        $('textarea').each(function () {
            this.setAttribute('style', 'height:' + this.scrollHeight + 'px;overflow-y:hidden;');
        });
    });

    $('body')
        .off('click', '.comp-faq h4.accordion-header button')
        .on('click', '.comp-faq h4.accordion-header button', function (e) {
            $('.comp-faq .accordion-item').removeClass('accordion-item-active');
            $(this).parents('.accordion-item').addClass('accordion-item-active');
        });

    //widowFix
    !(function (t) {
        $.fn.widowFix = function (i) {
            var n = t.extend({ letterLimit: null, prevLimit: null, linkFix: !1, dashes: !1 }, i);
            if (this.length)
                return this.each(function () {
                    var i,
                        e = t(this);
                    if (n.linkFix) {
                        var r = e.find('a:last');
                        r.wrap('<var>');
                        var l = t('var').html();
                        (i = r.contents()[0]), r.contents().unwrap();
                    }
                    var a = t(this).html().split(' '),
                        h = a.pop();
                    if (!(a.length <= 1)) {
                        if (
                            ((function t() {
                                '' === h && ((h = a.pop()), t());
                            })(),
                                n.dashes)
                        ) {
                            t.each(['-', '–', '—'], function (t, i) {
                                if (h.indexOf(i) > 0)
                                    return (h = '<span style="white-space:nowrap;">' + h + '</span>'), !1;
                            });
                        }
                        var s = a[a.length - 1];
                        if (n.linkFix) {
                            if (null !== n.letterLimit && i.length >= n.letterLimit)
                                return void e.find('var').each(function () {
                                    t(this).contents().replaceWith(l), t(this).contents().unwrap();
                                });
                            if (null !== n.prevLimit && s.length >= n.prevLimit)
                                return void e.find('var').each(function () {
                                    t(this).contents().replaceWith(l), t(this).contents().unwrap();
                                });
                        } else {
                            if (null !== n.letterLimit && h.length >= n.letterLimit) return;
                            if (null !== n.prevLimit && s.length >= n.prevLimit) return;
                        }
                        var u = a.join(' ') + '&nbsp;' + h;
                        e.html(u),
                            n.linkFix &&
                            e.find('var').each(function () {
                                t(this).contents().replaceWith(l), t(this).contents().unwrap();
                            });
                    }
                });
        };
    })($);
    $('h1, h2, h3, h4, h5, p, li').widowFix({
        letterLimit: 12,
        prevLimit: 8,
        //linkFix: false
    });

    $('.comp-policy-content').each(function () {
        $(this)
            .find('h3')
            .each(function (i) {
                var policyHeader = $(this).html();
                var policyHeaderSlug = policyHeader
                    .toLowerCase()
                    .trim()
                    .replace(/[^\w\s-]/g, '')
                    .replace(/[\s_-]+/g, '-')
                    .replace(/^-+|-+$/g, '');
                var policyNumber = `${i + 1}. `;
                $(this)
                    .parents('.comp-policy-content')
                    .find('.policy-toc')
                    .append(
                        `<p><a class="link link-no-arrow" href="#${policyHeaderSlug}">${policyNumber}${policyHeader}</a></p>`
                    );
                $(this).prepend(policyNumber).attr('id', policyHeaderSlug);
            });
    });

    if (document.location.pathname.includes('policies/gdpr-data-privacy')) {
        console.log('gdpr test');
        var gdprLink = document.querySelector('.comp-card-grid-container .col:nth-child(3) .card-link');
        if (gdprLink) {
            var gdprLink2 = document.createElement('a');
            gdprLink2.setAttribute('href', '/policies/lpbvdpa/');
            gdprLink2.setAttribute('class', 'card-link link gdpr-link2');
            gdprLink2.innerText = 'All other countries';
            gdprLink.after(gdprLink2);
        }
    }

    function slugifyContentTocHeading(text) {
        return text
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    function initContentToc() {
        document.querySelectorAll('.comp-content-toc').forEach(function (block, blockIndex) {
            var nav = block.querySelector('.comp-content-toc__nav');
            var content = block.querySelector('.comp-content-toc__content');
            if (!nav || !content) {
                return;
            }

            var headings = Array.from(content.querySelectorAll('h2, h3')).filter(function (heading) {
                return heading.textContent.trim();
            });

            nav.innerHTML = '';
            if (!headings.length) {
                block.classList.add('comp-content-toc--empty');
                return;
            }

            var slugCounts = {};
            var links = headings.map(function (heading, index) {
                var baseSlug = heading.id || slugifyContentTocHeading(heading.textContent) || `section-${index + 1}`;
                slugCounts[baseSlug] = (slugCounts[baseSlug] || 0) + 1;
                var slug = slugCounts[baseSlug] === 1 ? baseSlug : `${baseSlug}-${slugCounts[baseSlug]}`;

                if (!heading.id) {
                    heading.id = `content-toc-${blockIndex + 1}-${slug}`;
                }

                var link = document.createElement('a');
                link.className = `comp-content-toc__link comp-content-toc__link--${heading.tagName.toLowerCase()}`;
                link.href = `#${heading.id}`;
                link.textContent = heading.textContent;
                link.addEventListener('click', function (event) {
                    event.preventDefault();
                    heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    if (history.pushState) {
                        history.pushState(null, '', `#${heading.id}`);
                    }
                });
                nav.appendChild(link);
                return { heading: heading, link: link };
            });

            function setActive(activeItem) {
                links.forEach(function (item) {
                    item.link.classList.toggle('is-active', item === activeItem);
                });
            }

            var ticking = false;
            var updateActiveLink = function () {
                var activeItem = links[0];
                links.forEach(function (item) {
                    if (item.heading.getBoundingClientRect().top <= 150) {
                        activeItem = item;
                    }
                });
                setActive(activeItem);
                ticking = false;
            };
            var requestActiveLinkUpdate = function () {
                if (!ticking) {
                    window.requestAnimationFrame(updateActiveLink);
                    ticking = true;
                }
            };

            updateActiveLink();
            window.addEventListener('scroll', requestActiveLinkUpdate, { passive: true });
            window.addEventListener('resize', requestActiveLinkUpdate);
        });
    }

    initContentToc();

    if (document.location.pathname.includes('policies/public-cloud')) {
        if (window.sessionStorage.getItem('cloudPassword') == 'yes') {
            $('.lightbox').hide();
        }

        $('#loginbutton').on('click', function () {
            if ($('#password').val().toLowerCase() == 'cloud2024') {
                $('.lightbox').hide();
                $('.hide-this').show();
                window.sessionStorage.setItem('cloudPassword', 'yes');
            } else {
                $('.wrong-password').text('Incorrect password. Please double-check and try again.');
            }
        });
        $('#password').keypress(function (e) {
            if (e.which == 13) {
                if ($('#password').val().toLowerCase() == 'cloud2024') {
                    $('.lightbox').hide();
                    $('.hide-this').show();
                    window.sessionStorage.setItem('cloudPassword', 'yes');
                } else {
                    $('.wrong-password').text('Incorrect password. Please double-check and try again.');
                }
            }
        });
        $('#password').focus();
        $('#password').click(function () {
            $(this).attr('placeholder', '');
        });
    }

    // window.dataLayer.push({'event': 'optimize.activate'}); doesnt really work

    if (document.querySelectorAll('.resume-upload').length > 0) {
        console.log('Scripts: Start Careers Script');

        let ghsrc = Query.get('gh_src');
        console.log('ghsrc is: ' + ghsrc);

        document.querySelectorAll('.comp-body-container a').forEach(function (lnk) {
            var href = lnk.href.concat('&gh_src=').concat(ghsrc ?? '');
            lnk.href = href;
        });
        document.querySelectorAll('.resume-upload').forEach(function (lnk) {
            var href = lnk.href.concat('&gh_src=').concat(ghsrc ?? '');
            lnk.href = href;
        });

        let searchURL = 'https://careers.liveperson.com?source=campaignA'.concat('&gh_src=').concat(ghsrc ?? '');
        let keyWordQuery = document.getElementById('Job_Search').value;
        if (keyWordQuery !== '') {
            searchURL = searchURL.concat('&q=').concat(encodeURIComponent(keyWordQuery));
        }
        let submit = document.getElementById('Search_Submit_Button');
        submit.href = searchURL;

        function handleKey(e) {
            e.preventDefault();
            e.stopPropagation();

            if (e.keyCode === 13) {
                let searchURL = 'https://careers.liveperson.com?source=campaignA'
                    .concat('&gh_src=')
                    .concat(ghsrc ?? '');
                let keyWordQuery = document.getElementById('Job_Search').value;
                if (keyWordQuery !== '') {
                    searchURL = searchURL.concat('&q=').concat(encodeURIComponent(keyWordQuery));
                }
                console.log(`searchurl is ${searchURL}`);
                location.href = searchURL;
            }
        }

        function setURLParams(e) {
            let keyWordQuery = document.getElementById('Job_Search').value;

            let searchURLParams = 'https://careers.liveperson.com/?source=campaignA&q=';
            searchURLParams = searchURLParams
                .concat(encodeURIComponent(keyWordQuery))
                .concat('&gh_src=')
                .concat(ghsrc ?? '');

            let a = document.getElementById('Search_Submit_Button');
            let b = document.getElementById('wf-form-Search-Form');

            a.href = searchURLParams;
            b.setAttribute('action', searchURLParams);
        }

        document.getElementById('Job_Search').addEventListener('keyup', handleKey);
        document.getElementById('wf-form-Search-Form').addEventListener('keyup', handleKey);
        document.getElementById('Job_Search').addEventListener('input', setURLParams);

        document.querySelector('.resume-upload').addEventListener('click', function () { });

        //Adding fix for Vocal video here too
        if (!window.VocalVideo) {
            const head = document.getElementsByTagName('head')[0];
            const script = document.createElement('script');
            script.src = 'https://vocalvideo.com/embed/v1/host.js';
            head.appendChild(script);
            const iframe = document.querySelectorAll('iframe[title="Vocal Video"]')[0]; // only works with 1 gallery embed per page
            if (iframe) {
                iframe.src = iframe.src;
            }
        }

        console.log('Scripts: End Careers Script');
    }

    $('.comp-callout-grid-container .view-more-btn').on('click', function (el) {
        el.preventDefault();
        if ($(this).hasClass('collapse-btn')) {
            $(this).parent().siblings('.display-none').slideUp();
            $(this).text('View more').removeClass('collapse-btn');
        } else {
            $(this).parent().siblings().slideDown();
            $(this).text('Collapse').addClass('collapse-btn');
        }
    });

    if (document.querySelectorAll('#plain-content-text-carousel').length > 0) {
        var fixCarousel = $('#plain-content-text-carousel').html().replace('&nbsp;', '');
        $('#plain-content-text-carousel').html(fixCarousel);
    }

    if (document.querySelector('.thanks-download-link a[href="#report"]')) {
        let resourceAssetURLParam = Query.get('resourceasseturl');
        document.querySelector('.thanks-download-link a[href="#report"]').href =
            decodeURIComponent(resourceAssetURLParam);
    }

    if (document.querySelector('body.resources a[href="/resources/reports/socc-2024/"].post-link ')) {
        let reportLink = document.querySelector('body.resources a[href="/resources/reports/socc-2024/"].post-link ');
        reportLink.setAttribute(
            'href',
            '/customer-conversations-report/?utm_source=resources_library&utm_medium=direct&utm_campaign=socc_report_q1'
        );
        reportLink.setAttribute('target', '_blank');
    }

    if (document.location.pathname.includes('/guided-demo-library') && sessionStorage.getItem('guided-demo-email')) {
        let demoButton = document.querySelectorAll('.comp-program-card-container .btn-primary');
        demoButton.forEach((elem) => {
            let demoButtonLink = elem.getAttribute('href');
            elem.setAttribute('href', `${demoButtonLink}&guided_email=${sessionStorage.getItem('guided-demo-email')}`);
        });
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        const myForm = event.target;
        const formData = new FormData(myForm);

        fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(formData).toString(),
        })
            .then((response) => {
                var messageParagraph = $('<p>').addClass('thank-you-message').append('Thank you for your submission');
                $('.form-netlify').html('').append(messageParagraph);
            })
            .catch((error) => alert(error));
    };
    $('.form-netlify').on('submit', handleSubmit);
};
